import React from 'react'
import styled from 'styled-components'
import { Row, Col } from 'react-flexbox-grid';
import {Spacer} from 'layout/util'
import FillRestWithLine from 'pages/june-5/components/text-and-line'
import AnnotationsList from 'components/interactive/annotation/AnnotationsList';

const Title = styled.h2`
	display: inline-block;
	color: #333;
	margin: 10px 0;
`;

const Text = styled.div`
	margin-top: 10px;
`;


const TextBlock = (props) => {
	const {title, text} = props.data;
	const { showAnnos, pageId, loggedInUserId, authorUserId, sectionId } = 
		props.annoData ? props.annoData : 
		{showAnnos: false, pageId: null, loggedInUserId: null, authorUserId: null, sectionId: null};
	return(
		<Row>
	    <Col 
	    	xsOffset={1} xs={10} 
	      smOffset={2} sm={8} 
	      mdOffset={showAnnos?1:3} md={showAnnos?5:6} 
	      lgOffset={showAnnos?1:3} lg={showAnnos?5:6}
	    >
	    	<Spacer height={40}/>
				<FillRestWithLine trigger={showAnnos}>				
					<Title>{title}</Title>
				</FillRestWithLine>				
				<Text>{text}</Text>
			</Col>
			{showAnnos && 
		    <Col 
		    	xsOffset={1} xs={10} 
		      smOffset={2} sm={8} 
		      mdOffset={1} md={4} 
		      lgOffset={1} lg={4}
		    >
		    	<Spacer height={30}/>
					<AnnotationsList
            pageId={pageId}
            loggedInUserId={loggedInUserId}
            authorUserId={authorUserId}
            sectionId={sectionId}
          />
				</Col>
			}
		</Row>
	);
}

export default TextBlock


// WEBPACK FOOTER //
// ./src/pages/june-5/props/components/TextBlock.js